<template>
  <span>
    <slot></slot>
  </span>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import * as api from "~/api/resource";
import _ from "lodash";
export default {
  name: "data-loader",
  props: {
    target: { type: String, default: null },
    loadSrc: { type: String, default: null },
    extraParams: { default: null },
    gutter: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations({ setStore: "helpers/fetchRooms" })
  },
  async created() {
    const res = await api.fetchProcessor(this.loadSrc, {});
  }
};
</script>